export const DESCRIPTION_TEXT_MAX_CHAR = 1500;
export const DESCRIPTION_TEXT_ROWS = 3;
export const ADDITIONAL_INFO_TEXT_MAX_CHAR = 1500;
export const ADDITIONAL_INFO_TEXT_ROWS = 3;
export const SHORT_DESCRIPTION_TEXT_MAX_CHAR = 60;
export const SHORT_DESCRIPTION_TEXT_ROWS = 1;
